import { render } from "./CounterPage.vue?vue&type=template&id=ceedcd7e&scoped=true"
import script from "./CounterPage.vue?vue&type=script&lang=js"
export * from "./CounterPage.vue?vue&type=script&lang=js"

import "./CounterPage.vue?vue&type=style&index=0&id=ceedcd7e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ceedcd7e"]])

export default __exports__